export default "__VITE_ASSET__BqQj0Otp__"